import { gql } from "graphql-tag";
import { basePageableGraphqlField, responseField } from "../../../base.graphql";

export const sensorAlertDataFields = `id
uniqueId
sensorUniqueId
alertType
status
sensorSerialNumber
sensorName
warehouseName
warehouseUniqueId
reading
createdAt
updatedAt`;

export const GET_SENSOR_ALERT_DATA = gql`query GetSensorAlertData ($filtering:SensorAlertDataFilteringObject){
    getSensorAlertData(filtering: $filtering) {
        response {
            ${responseField}
        }
        page {
            ${basePageableGraphqlField}
        }
        data {
           ${sensorAlertDataFields}
        }
    }
}
`;

export const UPDATE_SENSOR_ALERT_DATA = gql`

mutation UpdateSensorAlertDataMutation($input: AlertReportInputObject!) {
    updateSensorAlertDataMutation(input: $input) {
        response {
            ${responseField}
        }
        data {
            id
            uniqueId
            totalAlerts
            createdAt
            status
            alertType
            reading
            updatedDate
        }
    }
}
`
